import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-action-box',
  templateUrl: './action-box.component.html',
  styleUrls: ['./action-box.component.scss'],
})
export class ActionBoxComponent implements OnInit {
  @Input() public isShowHint: boolean = true;
  @Input() public title: string = 'LABELS.ASSIGNED_CBP_ACTION_BOX.TITLE';
  @Input() public hint: string = 'LABELS.ASSIGNED_CBP_ACTION_BOX.HINT';
  @Input() public actionButtonText: string = 'LABELS.APPLY_HERE';
  @Output() public actionClick: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}

  public onActionClick() {
    this.actionClick.emit();
  }
}
